import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import {
  Field,
  Radio,
  RadioGroup,
  FluentProvider,
  webLightTheme,
  Textarea,
  Divider,
} from '@fluentui/react-components';
import React from 'react';
import { Controller, UseFormMethods } from 'react-hook-form';
import InlineFormInputErrorMessage from '../../../common/errorContent/InlineFormInputErrorMessage';
import CurrencyCodeDropdown from '../../../common/formFields/CurrencyCodeDropdown';
import ICashFlow from '../types';
import { yesOption, noOption } from '../../../../utils/types/CommonDropdownOptions';

interface ICashFlowFormProps {
  form: UseFormMethods<ICashFlow>;
  data: ICashFlow;
}

const CashFlowForm = ({ form, data }: ICashFlowFormProps): JSX.Element => {
  const { setValue, control } = form;

  return (
    <FluentProvider theme={webLightTheme}>
      <Stack tokens={{ childrenGap: 5 }}>
        <Controller
          name="cashFlowCurrency"
          control={control}
          defaultValue={data?.cashFlowCurrency}
          render={(): React.ReactElement => (
            <CurrencyCodeDropdown
              label="What are the cash flows of the entity's assets and liabilities in?"
              propertyName="CashFlowCurrency"
              handleChange={(newValue: string, valueKey: string): void => {
                setValue('cashFlowCurrency', newValue);
              }}
              defaultValue={data?.cashFlowCurrency}
              errorMessage=""
              width={500}
            />
          )}
        />
        <Controller
          control={control}
          name="cashFlowCurrencyNotes"
          defaultValue={data?.cashFlowCurrencyNotes}
          render={({ onChange, onBlur, value, name, ref }) => (
            <Field label="Notes">
              <Textarea
                id="cashFlowCurrencyNotes"
                value={value}
                name={name}
                ref={ref}
                onBlur={onBlur}
                onChange={(ev, textareaData) => {
                  onChange(textareaData.value);
                  setValue('cashFlowCurrencyNotes', textareaData.value);
                }}
              />
            </Field>
          )}
        />
        <Divider />
        <div>
          <Controller
            name="cashFlowAffectsParent"
            control={control}
            defaultValue={data?.cashFlowAffectsParent?.toString()}
            render={({ value }): React.ReactElement => (
              <>
                <Field
                  label="Do these cash flows directly affect the parent entity's cash flows and are they readily available for remittance to the parent entity?"
                  required
                >
                  <RadioGroup
                    id="CashFlowAffectsParent"
                    value={value?.toString()}
                    onChange={(e, radioData): void => {
                      setValue('cashFlowAffectsParent', radioData.value);
                    }}
                  >
                    <Radio value={yesOption.key} label={yesOption.text} />
                    <Radio value={noOption.key} label={noOption.text} />
                  </RadioGroup>
                </Field>
                <InlineFormInputErrorMessage errorMessage="" />
              </>
            )}
          />
        </div>
        <Controller
          control={control}
          name="cashFlowAffectsParentNotes"
          defaultValue={data?.cashFlowAffectsParentNotes}
          render={({ onChange, onBlur, value, name, ref }) => (
            <Field label="Notes">
              <Textarea
                id="cashFlowAffectsParentNotes"
                value={value}
                name={name}
                ref={ref}
                onBlur={onBlur}
                onChange={(ev, textareaData) => {
                  onChange(textareaData.value);
                  setValue('cashFlowAffectsParentNotes', textareaData.value);
                }}
              />
            </Field>
          )}
        />
      </Stack>
    </FluentProvider>
  );
};

export default CashFlowForm;
